export const START = "prevenx/loader/START"
export const STOP = "prevenx/loader/STOP"
export const REFRESH_START = "prevenx/loader/REFRESH_START"
export const REFRESH_STOP = "prevenx/loader/REFRESH_STOP"